import { Container, Typography, Box, Link, Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import OtpInput from "react-otp-input";
import IntroCard from "../components/Cards/IntroCard";
import SubmitButton from "../components/common/SubmitButton";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
import {
  constant,
  decryptData,
  encryptData,
  login,
  multiDecryption,
  randomAlphaNumeric,
  updateLocalStorageObj,
} from "../utils/utils";
import useSelector from "../store/selector";
import "../Style/Theme/index.css";
import { CONSTANTS } from "../utils/constant";
import Note from "../components/common/Note";
import { decryptApiData, encryptApiData, DataEncrypt } from "../utils/apiEncryption";
import Captcha from "../components/common/Captcha";
import ContainerWithLogo from "./ContainerWithLogo";
import ContainerForm from "./ContainerForm";
import ContainerSubmitButton from "../components/common/ContainerSubmitButton";

import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";

const OTP = ({ source }) => {
  const { getRecoilVal, setRecoilVal } = useSelector();

  let location = useLocation();
  let mn = location?.state?.mn;
  let queryParamOtp = location?.state?.queryParamOtp; // it will call through admin link
  // let AppId = location?.state?.AppId;
  let isEmail = location.state.isEmail;
  let em = location?.state?.em;
  let IsLimitEnhacement_Reduction_OTP =
    location?.state?.IsLimitEnhacement_Reduction;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [otp, setOTP] = useState("");
  const [error, setError] = useState("");
  const [reError, setreError] = useState(false);
  const [reDirect, setRedirect] = useState(false);
  const [counter, setCounter] = useState(10);
  const [resedCounter, setResedCounter] = useState(CONSTANTS.resendOTPTimer);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [attempt, setAttempt] = useState(0);
  const [eSignedData, setESignData] = useState();
  const [pfAmountShow, setPfAmountShow] = useState("");
  const [navigatetoNewPage, setNavigatetoNewPage] = useState(false);
  const [captchaMatched, setCaptchaMatched] = useState(false);
  const [randomCaptachData, setRandomCaptachData] = useState("");
  const [captchaData, setCaptchaData] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  const timerRef = useRef(null);
  const resendTimeRef = useRef(null);

  let st =
    "A five digit code is sent to this " +
    (isEmail
      ? "email id " + em.substring(0, 4) + "XXXXXXXXX"
      : "mobile no. XXXXXX" + mn.substring(6)) +
    (source === "f" ? " for documents verification" : "");
  let apicontroller = isEmail ? "EOTP" : "OTP";
  let rLink = isEmail ? t("Resend via Email") : t("Resend via SMS");
  const handleChange = (otp) => {
    setOTP(otp);
    if (otp.length === 5) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };
  let errors = {
    1: t("Invalid OTP. You have 2 attempts left."),
    2: t("Invalid OTP. This is your last attempt."),
    3: t(
      "Invalid OTP. You have no more attempts left. Please re-enter the correct " +
      (isEmail ? "email id." : "mobile number.")
    ),
  };
  // console.log("checl value---", JSON?.parse(eSignedData?.esignData));
  let ResendOTP = async (e) => {
    try {
      clearInterval(resendTimeRef.current);
      setLoading(true);
      const reqData = {
        mn: mn,
      };
      let resp = await apis.postApi(configData.API_URL + "OTP/SendOTP", {
        request: encryptApiData(reqData),
      });
      if (resp?.status === 200) {
        // setAttempt(attempt + 1);
        setOTP("");
        setError("");
        setreError(true);
        setDisabled(false);
        setResedCounter(CONSTANTS.resendOTPTimer);
        resendTimeRef.current = setInterval(() => {
          setResedCounter((resedCounter) => resedCounter - 1);
        }, CONSTANTS.otpInterval.INTERVALTIMER);
        setResendDisabled(true);
      }
      setLoading(false);
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setError(errorResult?.statusMessage);
      setLoading(false);
      //console.log(err);
    } finally {
      setRandomCaptachData(randomAlphaNumeric);
      setCaptchaMatched(false);
      setCaptchaData("");
    }
  };

  const validateCaptchaFun = () => {
    if (source === "f") {
      return true;
    }
    if (queryParamOtp) {
      return true;
    }
    if (!captchaData) {
      setCaptchaError("Enter Captcha");
      return false;
    }
    if (!captchaMatched) {
      setCaptchaError("InValid Captcha");
      setRandomCaptachData(randomAlphaNumeric);
      setCaptchaMatched(false);
      return false;
    }
    return true;
  };

  let handleSubmit = async (e) => {
    !queryParamOtp && e.preventDefault();
    setCaptchaError("");
    if (validateCaptchaFun()) {
      if (navigatetoNewPage) {
        // this condition for PF screen
        let getPreUserDatafromRecoil = getRecoilVal(
          constant.atomsName.USER_DETAIL
        );

        const getDecryptedProgrameName = await decryptData(
          getPreUserDatafromRecoil?.program
        );
        if (IsLimitEnhacement_Reduction_OTP === "Deduction") {
          let data = {
            AppId: pfAmountShow?.appid.toString(),
          };
          navigate("/new-approved-limit", { state: data });
        } else if (
          IsLimitEnhacement_Reduction_OTP === "Enhancement" &&
          getDecryptedProgrameName === "Agrostar_RF"
        ) {
          let data = {
            AppId: location?.state.AppId,
          };
          navigate("/new-approved-limit", { state: data });
        } else if (getDecryptedProgrameName === "Agrostar_RF") {
          let data = {
            AppId: location.state.AppId,
          };

          navigate("/BankDetails", { state: data });
        } else {
          let data = {
            AppId: pfAmountShow?.appid.toString(),
            // this is for UAT check, if 8 rupees present in .env file then this condition run, if prod env run then condition failed
            Amt: configData.PFamount
              ? configData.PFamount
              : pfAmountShow.pfAmount,
            // Amt: "8",
            mn: mn,
            IsLimitEnhacement_Reduction_PF: IsLimitEnhacement_Reduction_OTP,
          };
          navigate("/pfpayment", { state: data });
        }
        return;
      }
      setreError(false);
      setDisabled(true);
      try {
        // let getPreUserDatafromRecoil = getRecoilVal(
        //   constant.atomsName.USER_DETAIL
        // );

        // const getDecryptedProgrameName = await decryptData(
        //   getPreUserDatafromRecoil?.program
        // );
        setLoading(true);
        const reqData = {
          mn: mn,
          otp: otp || queryParamOtp,
          ty: source,
          // aid: AppId,
          DocTnC: location?.state?.DocTnC ? location?.state?.DocTnC : null,
          DocLoanAccount: location?.state?.DocLoanAccount
            ? location?.state?.DocLoanAccount
            : null,
          // programName: getDecryptedProgrameName,
        };
        let resp = await apis.postApi(`${configData.API_URL}OTP/VerifyOTP`, {
          request: DataEncrypt(reqData),
        });
        let result = await resp.json();
        if (resp?.status === 200) {
          // console.log("check inside gone or not");
          setLoading(false);
          if (source === "p") {
            setRecoilVal(
              constant.atomsName.USER_DETAIL,
              await login({
                anchor: location.state.anchor,
                program: location.state.program,
                source: location.state.source,
                mobileNum: mn,
                authToken: result?.data?.token,
              })
            );
            clearInterval(resendTimeRef.current);
            // if (decryptApiData(result?.data) === "True") {
            if (!result?.data?.path) {
              // if (result?.data === true || result?.data === "") {
              clearInterval(resendTimeRef.current);
              let data = {
                mn: mn,
                panno: "",
                AppId: result?.data?.appid.toString(),
                anchor: location.state.anchor,
                program: location.state.program,
                source: location.state.source,
              };
              navigate("/pan", { state: data });
            } else {
              // var oRData = JSON.parse(
              //   decryptApiData(result.data).trim().replaceAll("'", '"')
              // );
              var oRData = JSON.parse(
                result?.data?.path.trim().replaceAll("'", '"')
              );
              // var oRData = JSON.parse(result?.data?.path.trim());
              // var oRData = JSON.parse(result.data.trim().replaceAll("'", '"'));
              // console.log("check ORData---", oRData);
              // console.log("check ORData type---", typeof oRData);
              clearInterval(resendTimeRef.current);
              oRData.data.anchor = location.state.anchor;
              oRData.data.program = location.state.program;
              oRData.data.source = location.state.source;
              if (configData.PFamount) {
                // this is for UAT check, if 8 rupees present in .env file then this condition run, if prod env run then condition failed
                oRData.data.Amt = configData.PFamount;
              }
              // oRData.data.Amt = "8";
              oRData.data.mn = location?.state?.mn;
              // if (oRData.route === "/otp_p") {
              //   setDisabled(true);
              //   setAttempt(0);
              //   setError(false);
              //   setOTP("");
              // }
              console.log("check on route case----", oRData);
              navigate(oRData.route, { state: oRData.data });
            }
          } else if (source === "f") {
            // console.log("check in f condition");
            setError("");
            setESignData(JSON.parse(result?.data?.esignData));
            // setESignData(result?.data?.esignData);
            setPfAmountShow(result?.data);
            setNavigatetoNewPage(true);
            clearInterval(resendTimeRef.current);
            clearInterval(timerRef.current);
            setRedirect(false);
            setDisabled(false);
          } else {
            let data = { AppId: result?.data?.appid.toString() };
            navigate("/complete-kyc", { state: data });
          }
        }
      } catch (error) {
        setLoading(false);
        const errorResult = JSON.parse(error?.message);
        setDisabled(false);
        setAttempt(attempt + 1);
        setError(errorResult?.statusMessage);
        if (
          errorResult?.statusMessage ===
          "You Have Exceed the Limit of verifying OTP."
        ) {
          setDisabled(true);
          setRedirect(true);
          timerRef.current = setInterval(() => {
            setCounter((counter) => counter - 1);
            // console.log("calling");
          }, CONSTANTS.otpInterval.INTERVALTIMER);
          setResedCounter(CONSTANTS.resendOTPTimer);
          clearInterval(resendTimeRef.current);
          // navigate("/error", {
          //   state: {
          //     AppId: location.state.AppId,
          //     H: "Failed",
          //     Disc: errorResult?.statusMessage,
          //   },
          // });
        } else if (errorResult?.data === 1) {
          setDisabled(true);
          setRedirect(true);
          timerRef.current = setInterval(() => {
            setCounter((counter) => counter - 1);
            // console.log("calling");
          }, CONSTANTS.otpInterval.INTERVALTIMER);
          setResedCounter(CONSTANTS.resendOTPTimer);
          clearInterval(resendTimeRef.current);
          navigate("/error", {
            state: {
              AppId: location.state.AppId,
              H: "Journey Paused",
              Disc: "You have to wait for sales approval(politically exposed).",
              // otherMSG:
              //   "Please contact at phone - 9999999999 or email - support@tyger.com",
            },
          });
        } else if (errorResult?.data === 3) {
          setDisabled(true);
          setRedirect(true);
          timerRef.current = setInterval(() => {
            setCounter((counter) => counter - 1);
            // console.log("calling");
          }, CONSTANTS.otpInterval.INTERVALTIMER);
          setResedCounter(CONSTANTS.resendOTPTimer);
          clearInterval(resendTimeRef.current);
          navigate("/error", {
            state: {
              AppId: location.state.AppId,
              H: "Journey Rejected",
              Disc: "Your Journey is Rejected",
              // otherMSG:
              //   "Please contact at phone - 9999999999 or email - support@tyger.com",
            },
          });
        } else if (
          errorResult?.statusMessage ===
          // "Your Old OTP is Expired. We have send the new OTP to your registered Mobile Number."
          "Your Old OTP is Expired."
        ) {
          setDisabled(false);
          setResedCounter(CONSTANTS.resendOTPTimer);
          setRandomCaptachData(randomAlphaNumeric);
          setCaptchaMatched(false);
          setCaptchaData("");
        }
      }
    }
  };

  const handleRedirect = async () => {
    clearInterval(timerRef.current);

    // localStorage.setItem("blocker", new Date().toString());
    const blockerData = getRecoilVal(constant?.atomsName?.USER_BLOCKER);
    const objData = {
      storageName: "blocker",
      mobile: await encryptData(
        `${location.state.mn} |${location.state.source}| ${location.state.anchor} | ${location.state.program}`.toString()
      ),
      currTime: new Date(),
      operation: "update",
      data: blockerData,
    };
    // await updateLocalStorageObj(objData);
    setRecoilVal(
      constant?.atomsName?.USER_BLOCKER,
      await updateLocalStorageObj(objData)
    );
    navigate(
      `/${location.state.source}/${location.state.anchor}/${location.state.program}`
    );
  };

  useEffect(() => {
    setOTP("");
    setError(false);
    // setreError(true);
    // setDisabled(false);
    setResedCounter(CONSTANTS.resendOTPTimer);
    resendTimeRef.current = setInterval(() => {
      // console.log("qwerty---", resedCounter);
      setResedCounter((resedCounter) => resedCounter - 1);
    }, CONSTANTS.otpInterval.INTERVALTIMER);
    if (resedCounter === 0) {
      clearInterval(resendTimeRef.current);
      // setResendDisabled(false);
    }
    if (counter === 0) {
      clearInterval(timerRef.current);
    }
    setResendDisabled(true);
    setRandomCaptachData(randomAlphaNumeric);
    if (queryParamOtp) {
      // it will call when login URL get from admin
      handleSubmit();
    }
  }, []);

  useEffect(() => {
    async function fun() {
      // console.log(counter);
      if (counter === 0) {
        // console.log("counter 1 and redirect and clear interval");
        const blockerData = getRecoilVal(constant?.atomsName?.USER_BLOCKER);
        const objData = {
          storageName: "blocker",
          mobile: await encryptData(
            `${location.state.mn} |${location.state.source}| ${location.state.anchor} | ${location.state.program}`.toString()
          ),
          currTime: new Date(),
          operation: "update",
          data: blockerData,
        };
        // await updateLocalStorageObj(objData);
        setRecoilVal(
          constant?.atomsName?.USER_BLOCKER,
          await updateLocalStorageObj(objData)
        );
        navigate(
          `/${location.state.source}/${location.state.anchor}/${location.state.program}`
        );
        clearInterval(timerRef.current);
      }
      if (resedCounter === 0) {
        clearInterval(resendTimeRef.current);
        setResendDisabled(false);
      }
    }
    fun();
  }, [counter, resedCounter]);

  const downloadBase64File = (data) => {
    const downloadLink = document.createElement("a");
    downloadLink.href = `data:application/pdf;base64,${data.base64pdf}`;
    downloadLink.download = `${data.RespfileName}.pdf`;
    downloadLink.click();
  };

  const handleDownloadFile = () => {
    eSignedData?.map((data) => {
      downloadBase64File(data);
    });
  };

  let GuideString = "An OTP will be sent to your mobile number if it is registered in our system.";

  return (
    <>
      <ContainerWithLogo>
        {/* <ContainerForm
          component="form"
          onSubmit={handleSubmit}
          id="frmOTP"
          title="OTP"
          subtitle={st}
          icon={"/assets/OTP.svg"}
          showHeader={false}
        > */}

        <Box
          component="form"
          sx={{
            // p: "2px 2px",
            // mb: "10px",
            // top: "33%",
            // mt: "530px",
            marginTop: "310px",
            display: "flex",
            flexDirection: "column",
            // bottom: "8%",
            alignItems: "center",
            // boxShadow: "inset 0 0 5px #585858",
            // width: 400,
            bgcolor: "#e9e9e9",
            position: "absolute",
            backgroundColor: "#29417c",
          }}
        >
          <Box>
            <Typography
              sx={{
                color: "#fff",
                fontSize: "14px",
                mb: 2,
                textAlign: "center",
                px: 2,
                width: "100%",
                maxWidth: "320px",   // ✅ limits width
                wordBreak: "break-word", // ✅ prevents long text overflow
              }}
            >
              {GuideString}
            </Typography>
            <div>
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={5}
                inputType="tel"
                renderInput={(props) => (
                  <input {...props} disabled={navigatetoNewPage} />
                )}
                containerStyle="otpContainer"
                inputStyle={
                  error
                    ? "otpInput otpError"
                    : navigatetoNewPage
                      ? "otpInput otpDisable"
                      : "otpInput"
                }
                focusStyle="otpFocus"
              />
            </div>
            {error && (
              <Box mt={2} ml={1} sx={{ width: "380px" }}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {error}
                </Typography>
              </Box>
            )}
            {reError && (
              <Typography variant="p" color="subtitle" className="errorMsg_Th">
                Otp send to{" "}
                {isEmail
                  ? "email id " + em.substring(0, 4) + "XXXXXXXXX"
                  : "mobile no. XXXXXX" + mn.substring(6)}{" "}
                successfully. Please resend again in case you haven't received
                the OTP
              </Typography>
            )}

            {reDirect ? (
              <Box
                mt={0}
                mb={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "#222AE0",
                  fontWeight: "500",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    variant="p"
                    color="info"
                    sx={{ fontWeight: "500", ml: 1, color: "white" }}
                  >
                    You will redirect in {counter} Sec or{" "}
                    <Link onClick={handleRedirect}>click here</Link>
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box
                mt={0}
                mb={1}
                sx={{
                  display: navigatetoNewPage ? "none" : "flex",
                  // flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  color: "#222AE0",
                  fontWeight: "300",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    // cursor: "pointer",
                    // flexDirection: "column",
                  }}
                >
                  {resendDisabled === true ? (
                    <Typography
                      variant="p"
                      // color="info"
                      sx={{
                        fontWeight: "500",
                        ml: 1,
                        fontSize: "13px",
                        color: "#a2a2a2",
                        mt: "3px",
                      }}
                    >
                      You can resend otp after {resedCounter} second
                    </Typography>
                  ) : (
                    <>
                      {/* <img src="/assets/message.svg" alt="message" sizes="m"/> */}
                      <TextsmsOutlinedIcon sx={{ color: "#a2a2a2" }} />
                      <Link onClick={ResendOTP}>
                        <Typography
                          variant="p"
                          // color="info"
                          sx={{
                            fontWeight: "500",
                            cursor: "pointer",
                            ml: 1,
                            fontSize: "13px",
                            color: "#a2a2a2",
                            mt: -1,
                          }}
                        >
                          {rLink}
                        </Typography>
                      </Link>
                    </>
                  )}
                </Box>
              </Box>
            )}

            {loading && (
              <Backdrop ax="center">
                <LoadingDots />
              </Backdrop>
            )}
          </Box>
        </Box>
        {/* </ContainerForm> */}

        <Box
          // className="borderColor"
          sx={{
            borderRadius: "10px",
            p: "5px",
            display: source === "f" && "block",
            // bottom: "5%",
            position: "absolute",
            top: "71%",
          }}
        >
          {source === "f" && eSignedData?.length > 0 && (
            <>
              <Note note="Please click below button to download the signed document" />
              <Button
                variant="contained"
                onClick={handleDownloadFile}
                sx={{ mt: -3, ml: 3 }}
                size="small"
              >
                Download Document
              </Button>
            </>
          )}
        </Box>

        <Box
          className="borderColor"
          sx={{
            borderRadius: "10px",
            p: "5px",
            display: source === "f" && "none",
            // bottom: "5%",
            position: "absolute",
            top: "78%",
          }}
        >
          <Captcha
            captchaMatched={captchaMatched}
            setCaptchaMatched={setCaptchaMatched}
            randomCaptachData={randomCaptachData}
            setRandomCaptachData={setRandomCaptachData}
            setCaptchaData={setCaptchaData}
            captchaData={captchaData}
          />

          {captchaError && (
            <Box mt={1} ml={0}>
              <Typography variant="p" color="subtitle" className="errorMsg_Th">
                {captchaError}
              </Typography>
            </Box>
          )}
          {/* </Box> */}
        </Box>
        <Box
          // onSubmit={handleSubmit}
          sx={{ position: "absolute", bottom: "5%" }}
        >
          <Link onClick={handleSubmit}>
            <Button
              // variant="contained"
              // sx={{
              size="small"
              variant="contained"
              sx={{
                // borderRadius: 2,
                // mt: 1,
                // bgcolor: "#a6ce39",

                borderRadius: "1",
                mt: 1,
                bgcolor: "#a6ce39",
                borderRadius: 3,
                bgcolor: "#a6ce39",
                width: "200px",
              }}
            >
              Continue
            </Button>
          </Link>
          {/* <ContainerSubmitButton disabled={disabled} onSubmit={handleSubmit} /> */}
        </Box>
      </ContainerWithLogo>
    </>
  );
};
export default OTP;
